import styled from "@emotion/styled";
import { Chip } from "@mui/material";

const SuccessChips = styled(Chip)(({ theme, variant }) => {
    return {
        backgroundColor: theme.palette.success.light,
        color: theme.palette.success.main,
        fontWeight: 600,
        padding: '2px 8px',
        borderRadius: '4px',
        borderColor: variant === 'outlined' ? theme.palette.success.main : null,
        '& .MuiChip-icon': {
            color: theme.palette.success.main,
        }
    }
});
const ErrorChips = styled(Chip)(({ theme, variant }) => {
    return {
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.main,
        fontWeight: 600,
        padding: '2px 8px',
        borderRadius: '4px',
        borderColor: variant === 'outlined' ? theme.palette.error.main : null,
        '& .MuiChip-icon': {
            color: theme.palette.error.main,
        }
    }
});
const InfoChips = styled(Chip)(({ theme, variant }) => {
    return {
        backgroundColor: theme.palette.info.light,
        color: theme.palette.info.main,
        fontWeight: 600,
        padding: '2px 8px',
        borderRadius: '4px',
        borderColor: variant === 'outlined' ? theme.palette.info.main : null,
        '& .MuiChip-icon': {
            color: theme.palette.info.main,
        }
    }
});
const WarningChips = styled(Chip)(({ theme, variant }) => {
    return {
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.main,
        fontWeight: 600,
        padding: '2px 8px',
        borderRadius: '4px',
        borderColor: variant === 'outlined' ? theme.palette.warning.main : null,
        '& .MuiChip-icon': {
            color: theme.palette.warning.main,
        }
    }
});
export { SuccessChips, ErrorChips, InfoChips, WarningChips }

// usage
{/* <InfoChips label='Open' variant='outlined' icon={<FiberManualRecordIcon />} sx={{ marginLeft: 1 }} />
<ErrorChips label='error' variant='outlined' icon={<FiberManualRecordIcon />} />
<SuccessChips label='Succes' variant='outlined' icon={<FiberManualRecordIcon />} />
<WarningChips label='warning' variant='outlined' icon={<FiberManualRecordIcon />} /> */}